<a href="javascript:void(0)" (click)="onOpenModal()">

<img photoUrl 
    class="product-image"  
    [attr.src]="productPhotoUrl" 
    alt=""
    [style.width]="Width +  'px'"
    [attr.width]="Width"
    >

</a>
